<div class="container " style="height: 100%; padding: 40px;background-color: #f9f9f9;">
  <div class="col-sm-12" style="border: 5px solid #efefef; padding: 20px 20px 0; margin-bottom: 30px;">
      <div class="col-sm-6">
          <div class=" empty"></div>
      </div>
      <div class="col-sm-6">
          <div class=" empty"></div>
      </div>
      <div class="col-sm-6">
          <div class=" empty"></div>
      </div>
      <div class="col-sm-6">
          <div class=" empty"></div>
      </div>
  </div>
      
  <div style="border: 5px solid #efefef; padding: 20px 20px 20px 25px;margin-top: 180px;">
      <img src="assets/images/emptytable.svg" style="width:100%"/>
  </div>
</div>